import UserIcon from "assets/images/defaultIcons/user.svg";
import React, { useEffect, useState } from "react";
import FileUpload from "webComponentsFormElements/inputs/FileUpload.component";

export default function UserImageUpload({ onImageChange }) {
  // Manage image state internally for new user creation
  const [userImage, setUserImage] = useState(null);
  const [userImageBlob, setUserImageBlob] = useState(null);

  // Notify parent when image changes
  useEffect(() => {
    onImageChange?.(userImage, userImageBlob);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userImage, userImageBlob]); // onImageChange should be stable from parent

  return (
    <FileUpload
      placeholderIcon={UserIcon}
      file={userImage}
      setFile={(image) => {
        setUserImage(image);
      }}
      setFileBlob={setUserImageBlob}
    />
  );
}
